import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Popover, Paper, Typography } from '@material-ui/core';
import LabelIcon from '@material-ui/icons/Label';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { i18n } from '../../translate/i18n';

const useStyles = makeStyles(theme => ({
    menuPaper: {
        minWidth: "300px !important",
        width: "auto !important",
        maxWidth: "unset !important",
        borderRadius: "12px !important",
        boxShadow: "0 8px 24px rgba(0,0,0,0.15) !important",
        maxHeight: '80vh',
        overflowY: 'auto'
    }
}));

const KanbanTagMenu = ({
    position,
    ticket,
    lanes,
    onClose,
    updateTicket,
    setTargetLaneIdForAdd,
    setAddSubTagModalOpen,
    currentLaneId
}) => {
    const classes = useStyles();
    const [localTags, setLocalTags] = useState([]);

    useEffect(() => {
        if (ticket && ticket.tags) {
            setLocalTags(ticket.tags);
        }
    }, [ticket]);

    const handleAddTag = async (tag, targetLaneTitle) => {
        try {
            let tagObj = tag;
            let tagId = tag.id;

            const currentTags = localTags;
            const alreadySelected = currentTags.some(t => String(t.id) === String(tagId));

 let newTags;
            if (alreadySelected) {
                newTags = currentTags.filter(t => String(t.id) !== String(tagId));
                // Fire and forget
                api.delete(`/ticket-tags/${ticket.id}/${tagId}`).catch(e => console.warn(e));
            } else {
                newTags = [...currentTags, tagObj];
                // Fire and forget
                api.post(`/ticket-tags/${ticket.id}/${tagId}`, {}, {
                    params: { origin: 'inbox' }
                }).catch(e => console.warn(e));
            }

            setLocalTags(newTags);
            if (updateTicket) {
                // Optimistic update to parent (updating updatedAt so it triggers re-render)
                updateTicket({ ...ticket, tags: newTags, updatedAt: new Date().toISOString() });
            }} catch (err) {
            console.error(err);
        }
    };

    if (!position || !ticket) return null;

    return (
        <Popover
            open={true}
            anchorReference="anchorPosition"
            anchorPosition={{ top: position.top, left: position.left + 20 }}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            classes={{ paper: classes.menuPaper }}
        >
            {lanes.map((lane, index) => {
                if (lane.id === 'lane0') return null;

                // Find current lane index (roughly)
                const currentLaneIdx = lanes.findIndex(l => l.id === currentLaneId);
                const isFuture = index > currentLaneIdx;

                let laneTagsRender = [];
                if (lane.kanbanLaneTags && lane.kanbanLaneTags.length > 0) {
                    laneTagsRender = lane.kanbanLaneTags.map(klt => klt.tag);
                }

                const titleStyle = {
                    backgroundColor: '#f5f5f5',
                    padding: '8px 16px',
                    fontWeight: 400,
                    color: isFuture ? '#aaa' : '#333',
                    fontSize: '0.65rem',
                    borderBottom: '1px solid #eee',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                };

                return (
                    <div key={lane.id} style={{ opacity: isFuture ? 0.6 : 1, pointerEvents: isFuture ? 'none' : 'auto' }}>
                        <div style={titleStyle}>
                            <span>{lane.title} {isFuture && "🔒"}</span>
                            {!isFuture && (
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setTargetLaneIdForAdd(lane.id);
                                        setAddSubTagModalOpen(true);
                                    }}
                                    style={{ cursor: 'pointer', color: '#2196f3', fontSize: '1.2rem', lineHeight: 0.5 }}
                                    title={i18n.t("tagsKanban.table.add")}
                                >
                                    +
                                </div>
                            )}
                        </div>

                        {laneTagsRender.length === 0 && !isFuture && (
                            <div style={{ padding: '8px 16px', color: '#999', fontSize: '0.8rem', fontStyle: 'italic' }}>
                                Sin etiquetas
                            </div>
                        )}

                        {laneTagsRender.map(tag => {
                            const matchedTag = localTags.find(t => String(t.id) === String(tag.id));
                            const isSelected = !!matchedTag;
                            const tagColor = lane.color || tag.color || '#555';

                            return (
                                <div
                                    key={tag.id}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleAddTag(tag, lane.title);
                                    }}
                                    style={{
                                        padding: '8px 16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        backgroundColor: isSelected ? 'rgba(0, 0, 0, 0.04)' : 'transparent',
                                        borderLeft: isSelected ? `4px solid ${tagColor}` : '4px solid transparent',
                                        transition: 'background-color 0.2s',
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.08)'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = isSelected ? 'rgba(0, 0, 0, 0.04)' : 'transparent'}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                        <div style={{ marginRight: 10 }}>
                                            <LabelIcon style={{ color: tagColor, fontSize: 20 }} />
                                        </div>
                                        <span style={{ fontWeight: 300, fontSize: '0.75rem', letterSpacing: '0.3px', fontFamily: 'Roboto, sans-serif' }}>{tag.name}</span>
                                        {isSelected && <CheckCircleIcon style={{ fontSize: 18, color: tagColor, marginLeft: 'auto' }} />}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        </Popover>
    );
};

export default KanbanTagMenu;
